import React, { useEffect } from 'react';
import { Card, Tab } from 'react-bootstrap';

import { CardsList } from '../../components/Cards/CardsList';
import { TabsHistory } from '../../../app/components/TabsHistory';
import { useSzafir } from '../../../common/hooks/useSzafir';
import { useAuth } from '../../../common/hooks/useAuth';

export const CardsView: React.FC = () => {
  const szafir = useSzafir();
  const auth = useAuth();

  useEffect(() => {
    if (auth.canSign) {
      szafir.activate(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.canSign]);

  return (
    <Card>
      <TabsHistory activeKey="search" id="cards" className="mb-3">
        <Tab eventKey="search" title="Karty" className="m-3">
          <CardsList />
        </Tab>
      </TabsHistory>
    </Card>
  );
};
